import { TestType } from "@/queries/types";
import styled from "@emotion/styled";

export const TestContainer = styled.div<{
  testType: TestType;
}>`
  display: flex;
  position: relative;
  flex-grow: 1;
  flex-direction: column;
  margin-top: 32px;
  background: ${(props) => props.theme.colors.white};

  @media (min-width: 768px) {
    padding: 40px 8px 0;
    flex-direction: row;
    background: none;
    margin-top: 88px;
    height: ${(props) =>
      props.testType === "video" ? "100%" : `calc(100vh - 88px)`};
  }
`;
